import styled from "styled-components";
import { Flex } from "uikit";

const Root = styled(Flex)`
	width: 100vw;
	height: 100vh;
`;

export default Root;
